import { Typography } from '@mui/material';

import { formatBooleanLabel } from '../utils';

type BooleanStatusCellProps = {
  value: boolean;
};

const BooleanStatusCell = ({ value }: BooleanStatusCellProps) => {
  return <Typography variant='body2'>{formatBooleanLabel(value)}</Typography>;
};

export default BooleanStatusCell;
